import {SET_HORSE_RACING_DATA} from "./actionTypes";

const setHorseRacingData = (payload) => {
    return {
        type: SET_HORSE_RACING_DATA,
        payload
    };
};

export const getHorseRacingData = (id, creation_source) => {
    return (dispatch) => {
        const url = `https://horseracing.betcoapps.com/rc/${id}.json`;
        // const url = `https://horseracing.betcoapps.com/${creation_source === 1 ? 'SIS' : 'PA'}/Matches${creation_source === 1 ? '/Horse' : ''}/${id}/${id}.json`;
        fetch(url)
            .then(res => res.json())
            .then(res => dispatch(setHorseRacingData(res)))
            .catch(err => { console.log(err); dispatch(setHorseRacingData({})); });
    };
};